/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { DirectionalHint, Callout, Stack, Spinner } from '@fluentui/react';
import BlockUi from 'react-block-ui';
import {
  Button,
  Caption1Stronger,
  Caption1,
} from '@fluentui/react-components';

import { fetchPerformanceInsightsData } from './util/service';
import { normalizeData } from './util/util';
import {
  PERFORMANCE_INSIGHTS_TYPE,
  PERFORMANCE_INSIGHTS_ISSUE,
  PERFORMANCE_INSIGHTS_POPUP_CONFIG,
  PERFORMANCE_INSIGHTS_PANEL_CONTAINER,
} from './constants/consts';
import { calloutStyles } from './style/style';
import { PerformanceInsightsPanel } from './performance-insights-panel';

export const PerformanceInsightsToolTipCard = (props) => {
  const {
    event,
    closePerformanceInsightsPopup,
    i18n,
    newI18n,
    entity,
    serverContext,
  } = props;
  const [isBlocking, setIsBlocking] = useState(true);
  const [allData, setAllData] = useState(null);
  const onClick = () => {
    closePerformanceInsightsPopup();
    ReactDOM.render(
      (<PerformanceInsightsPanel
        entity={entity}
        newI18n={newI18n}
        allData={allData}
      />),
      document.querySelector(PERFORMANCE_INSIGHTS_PANEL_CONTAINER)
    );
  };
  useEffect(() => {
    fetchPerformanceInsightsData({ serverContext }).then((value) => {
      let result = {};
      if (value && !_.isEmpty(value.CheckpointResults)) {
        value.CheckpointResults.push({
          CheckpointDataMap: [
            {
              CheckpointDataJsonString: '[{"AccountId":334,"CampaignId":614007743,"MaxDate":"2/27/2025 4:00:00 PM","minDate":"2/21/2025 4:00:00 PM","OriginalBudget":100,"RecommendedBudget":121,"MissingImpressions":386,"MissingClicks":31.87280701754385964912280701,"BudgetPoints":[{"Date":"2025-03-06T00:00:00","Impressions":2522,"Clicks":208,"ProjectedImpressionsRecommendedBudget":2908,"ProjectedClicksRecommendedBudget":240},{"Date":"2025-03-05T00:00:00","Impressions":2610,"Clicks":237,"ProjectedImpressionsRecommendedBudget":2912,"ProjectedClicksRecommendedBudget":264},{"Date":"2025-03-04T00:00:00","Impressions":3038,"Clicks":229,"ProjectedImpressionsRecommendedBudget":3428,"ProjectedClicksRecommendedBudget":258},{"Date":"2025-03-03T00:00:00","Impressions":2587,"Clicks":193,"ProjectedImpressionsRecommendedBudget":3031,"ProjectedClicksRecommendedBudget":226},{"Date":"2025-03-02T00:00:00","Impressions":2312,"Clicks":192,"ProjectedImpressionsRecommendedBudget":2653,"ProjectedClicksRecommendedBudget":220},{"Date":"2025-03-01T00:00:00","Impressions":2448,"Clicks":183,"ProjectedImpressionsRecommendedBudget":2539,"ProjectedClicksRecommendedBudget":190},{"Date":"2025-02-28T00:00:00","Impressions":1893,"Clicks":136,"ProjectedImpressionsRecommendedBudget":2113,"ProjectedClicksRecommendedBudget":152}]}]',
            },
          ],
          CheckpointKey: 'BudgetConstraint',
        });
        result = normalizeData({ checkpointResults: value.CheckpointResults, i18n, serverContext });
      }
      setAllData(result);
      setIsBlocking(false);
    });
  }, []);
  // TODO: get type and subType from real api
  const type = PERFORMANCE_INSIGHTS_TYPE.ISSUE;
  const subType = PERFORMANCE_INSIGHTS_ISSUE.BUDGET;
  return (
    <div onMouseLeave={closePerformanceInsightsPopup}>
      <Callout className={`performance-insights-callout ${calloutStyles.callout}`} target={event.target} directionalHint={DirectionalHint.rightCenter} role="alert" >
        <BlockUi blocking={isBlocking} loader={<Spinner />}>
          {!isBlocking &&
            <React.Fragment>
              <Caption1Stronger>{newI18n.getString(PERFORMANCE_INSIGHTS_POPUP_CONFIG[type][subType].title)}</Caption1Stronger>
              <Stack tokens={{ childrenGap: 16 }}>
                <Caption1>{newI18n.getString(PERFORMANCE_INSIGHTS_POPUP_CONFIG[type][subType].description, allData[subType])}</Caption1>
                <Caption1>{newI18n.getString(PERFORMANCE_INSIGHTS_POPUP_CONFIG[type][subType].pitching)}</Caption1>
              </Stack>
              <Button appearance="primary" onClick={onClick}>
                {newI18n.getString(PERFORMANCE_INSIGHTS_POPUP_CONFIG[type][subType].action)}
              </Button>
            </React.Fragment>
          }
        </BlockUi>
      </Callout>
    </div>
  );
};

PerformanceInsightsToolTipCard.propTypes = {
  event: PropTypes.shape({
    target: PropTypes.shape({}).isRequired,
  }).isRequired,
  closePerformanceInsightsPopup: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    formatDate: PropTypes.func.isRequired,
  }).isRequired,
  newI18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  entity: PropTypes.shape({}).isRequired,
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.shape({
      TimeZone: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};
